// Scroll-Reveal: Inhalte faden + steigen sanft ein, sobald sie in den Viewport
// scrollen (IntersectionObserver); Karten-Raster gestaffelt. Zusätzlich „wischt"
// der Marken-Farb-Balken segmentweise ein.
//
// Progressive Enhancement: Ohne JS (kein .reveal-on / kein data-reveal) bleibt
// alles sofort sichtbar. Bei prefers-reduced-motion (§16) steigt das Modul aus,
// es wird nichts versteckt. Bereits im Viewport liegende Inhalte werden ohne
// Animation sofort gezeigt (kein „Aufblitzen" beim Laden). Dynamische Werte
// (Stagger-Index) laufen über die CSS-Custom-Property --reveal-i; die eigentlichen
// Regeln stehen im Stylesheet (_reveal.scss) -> §8-konform.

// Einzelne Inhaltsblöcke (faden + steigen).
const SINGLES = [
  ".iba-section-head",
  ".planungsphasen__head",
  ".text-teaser__inner",
  ".bild-text__text",
  ".bild-text__media",
  ".medien-banner__card",
  ".testimonial__card",
  ".cta-kontakt__inner",
  ".kontaktformular__head",
  ".kontaktformular__body",
  ".bewerbungsformular__head",
  ".bewerbungsformular__body",
  ".stellen-bewerbung__head",
];

// Raster: deren direkte Kinder reihum gestaffelt einblenden. Filterbare Raster
// (Team, Referenzen) sind bewusst NICHT dabei — sie haben ihre eigene Filter-
// Animation (filteranim.js); ein Reveal darauf würde um opacity/transform konkurrieren.
const GROUPS = [
  ".stellenangebote__grid",
  ".teaser-tafeln__grid",
  ".text-boxen__grid",
  ".stellen-bewerbung__cards",
  ".info-cards__grid",
  ".bilder-paar",
];

// Gepinnte Horizontal-Scroll-Module, Hero und Header sind ausgenommen (eigenes
// Verhalten / LCP-Bereich) — der Farb-Balken ist davon bewusst NICHT betroffen.
const EXCLUDE = ".iba-hscroll, .site-header, .hero";

export function initReveal() {
  if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
    return;
  }
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const targets = new Set();

  const tag = (el, index) => {
    if (!el || targets.has(el) || el.closest(EXCLUDE)) {
      return;
    }
    el.setAttribute("data-reveal", "");
    if (index > 0) {
      el.style.setProperty("--reveal-i", String(index));
    }
    targets.add(el);
  };

  for (const sel of SINGLES) {
    document.querySelectorAll(sel).forEach((el) => tag(el, 0));
  }
  for (const sel of GROUPS) {
    document.querySelectorAll(sel).forEach((group) => {
      [...group.children].forEach((child, i) => tag(child, i));
    });
  }

  // Farb-Balken segmentweise einwischen (auch im Hero — bewusste Marken-Geste).
  const balken = [...document.querySelectorAll(".farb-balken")];
  balken.forEach((el) => el.setAttribute("data-reveal-balken", ""));

  if (!targets.size && !balken.length) {
    return;
  }
  document.documentElement.classList.add("reveal-on");

  const reveal = (entries, obs) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-revealed");
        obs.unobserve(entry.target);
      }
    }
  };

  const io = new window.IntersectionObserver(reveal, {
    rootMargin: "0px 0px -10% 0px",
    threshold: 0.12,
  });

  // Eigener Observer für die Farb-Balken: ohne negativen Bottom-Margin und mit
  // threshold 0. Der -10%-Bottom-Margin des Haupt-Observers blendet die unteren
  // 10% des Viewports aus; ein unten verankerter Balken (Footer, position:
  // absolute; bottom:0) erreicht die Trigger-Zone sonst nie und bliebe unsichtbar.
  const ioBalken = new window.IntersectionObserver(reveal, {
    rootMargin: "0px",
    threshold: 0,
  });

  // Bereits sichtbare Blöcke ohne Animation sofort zeigen (kein Flash beim Laden);
  // nur darunterliegende werden beim Hereinscrollen animiert.
  const fold = window.innerHeight * 0.9;
  targets.forEach((el) => {
    if (el.getBoundingClientRect().top < fold) {
      el.classList.add("is-revealed");
    } else {
      io.observe(el);
    }
  });

  // Der Farb-Balken soll auch oberhalb der Falz animieren (die Geste IST der Effekt).
  balken.forEach((el) => ioBalken.observe(el));
}
